import { BaseTableWidget, SPI, TableWidget, TableWidgetProps, ViewType } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseTableWidget.Token({
    widget: 'ActionCountTable'
  })
)
export class ActionCountTableWidget extends TableWidget {
  initialize(props: TableWidgetProps) {
    super.initialize(props);
    this.getDsl().inlineActiveCount = 5;
    return this;
  }
}
